import { localStorageService } from 'common/utilities/LocalStorageService';

export function setAuthBreakpoint(): void {
  if (localStorageService.getItem('authBreakpoint') === 'true') {
    // eslint-disable-next-line no-debugger
    debugger;
  }
}
